import { createFileRoute, redirect } from '@tanstack/react-router'

import i18n from '@/i18n'
import {
  CoveredAndCancelledLessonsView,
  CoveredLessonsView,
  lessonsFiltersSchema
} from '@/modules/coveredAndCancelledLessons'
import { semesterQueryOptions } from '@/queries/useSemesters'
import { getMetaWithPageTitle } from '@/utils/get-page-title'
import { isSelectedSemesterInOptions } from '@/utils/is-selected-semester-in-options'

export const createCoveredOrCancelledLessonsRoute = (
  path: 'covered' | 'cancelled',
  component: () => JSX.Element
) =>
  createFileRoute(`/_auth/covered-and-cancelled-lessons/${path}`)({
    validateSearch: lessonsFiltersSchema,
    component,
    loaderDeps: ({ search }) => ({
      ...search
    }),
    loader: async ({ deps: search, context }) => {
      const semesters = await context.queryClient.ensureQueryData(
        semesterQueryOptions({})
      )

      if (
        !search.semesterId ||
        !isSelectedSemesterInOptions(
          search.semesterId,
          semesters.semestersFromCurrentYearOptions
        )
      ) {
        throw redirect({
          to: `/covered-and-cancelled-lessons/${path}`,
          replace: true,
          search: { ...search, semesterId: semesters.currentSemester?.id }
        })
      }
    },
    head: () =>
      getMetaWithPageTitle([
        i18n.t('title.covered-and-cancelled-lessons', {
          ns: 'coveredCancelledLessons'
        }),
        i18n.t(`title.${path}-lessons`, { ns: 'coveredCancelledLessons' })
      ])
  })

export const Route = createCoveredOrCancelledLessonsRoute('covered', () => (
  <CoveredAndCancelledLessonsView>
    <CoveredLessonsView />
  </CoveredAndCancelledLessonsView>
))
